import React, { FunctionComponent, memo, ReactElement } from 'react'
import styled from 'styled-components'
import { text } from '../../styles'
import Grid from '../Grid'
import { AlignTypes, TextProps, WebHeadlineTypes } from '../../styles/types'
import transformProps from '../../styles/utils/transformProps'
import { layoutConfig } from '../../styles/properties/layout'
import { numberOfLines } from '../../styles/properties/numberOfLines'
import { StyleType } from '../../styles/utils/transformProps/types'

export const BaseText = styled.span<TextProps>`
    ${numberOfLines}
    ${text}
    ${(props): StyleType | undefined =>
        props.maxHeight ? transformProps(layoutConfig, props) : undefined}
`

BaseText.defaultProps = {
    selectable: true,
}

export type UniversalTextProps = TextProps & {
    // webHeadlineType is web only
    webHeadlineType?: WebHeadlineTypes
    textAlign?: AlignTypes | AlignTypes[]
    className?: string
}

export const Text: FunctionComponent<UniversalTextProps> = ({
    children,
    textAlign,
    webHeadlineType,
    fontSize = 16,
    fontWeight = 'normal',
    margin = 0,
    backgroundColor,
    testID,
    className,
    ...rest
}): ReactElement => {
    let alignment
    if (textAlign === 'center') {
        alignment = {
            center: true,
        }
    } else if (textAlign === 'right') {
        alignment = {
            alignRight: true,
        }
    } else {
        alignment = {
            alignLeft: true,
        }
    }

    return (
        <Grid horizontal noExpand {...alignment} backgroundColor={backgroundColor}>
            <BaseText
                as={webHeadlineType}
                textAlign={textAlign}
                fontSize={fontSize}
                fontWeight={fontWeight}
                margin={margin}
                className={className}
                {...rest}
                data-testid={testID}
            >
                {children}
            </BaseText>
        </Grid>
    )
}

// prevent rerendering if parent component rerenders without changing the props of the text
export default memo(Text)
